import React, { useContext } from 'react';
import styled from 'styled-components';
import { LanguageContext } from '../../context/LanguageContext';
import { colors } from '../../styles/theme';
import Logo from '../common/Logo';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background: ${colors.darker};
  padding: 2rem;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.05);

  @media (max-width: 1024px) {
    padding: 1.75rem;
  }

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;

const LegalLinks = styled.nav`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.6rem 1.25rem;
  margin: 1rem auto;
  a { color: ${colors.gray}; font-size: 0.8rem; text-decoration: none; }
  a:hover, a:focus-visible { color: white; text-decoration: underline; }
`;

const Copyright = styled.p`
  color: ${colors.gray};
  font-size: 0.9rem;
  opacity: 0.7;
`;

const Footer = () => {
  const { language, translations } = useContext(LanguageContext);
  const t = translations[language].footer;

  return (
    <FooterContainer>
      <LogoContainer>
        <Logo 
          src="/images/logo.png"
          height="50px"
          mobileHeight="40px"
          fontSize="2rem"
          mobileFontSize="1.8rem"
        />
      </LogoContainer>
      <LegalLinks aria-label={language === 'tr' ? 'Yasal belgeler' : 'Legal documents'}>
        {['babymee', 'space-span'].map(app => ['privacy', 'terms'].map(type => (
          <Link key={`${app}-${type}`} to={`/legal/${app}/${type}`}>
            {app === 'babymee' ? 'BabyMee' : 'Space Span'} · {type === 'privacy' ? (language === 'tr' ? 'Gizlilik' : 'Privacy') : (language === 'tr' ? 'Kullanım Koşulları' : 'Terms')}
          </Link>
        )))}
      </LegalLinks>
      <Copyright>
        {t.copyright}
      </Copyright>
    </FooterContainer>
  );
};

export default Footer; 